module.exports = __webpack_public_path__ + "img/Carousel_Header1.3ad7d575.png";